import get from "lodash/get";
import type { Action } from "../../actions/types";

export type StoreState = {
  count: number;
  records: ShopifyDiscountRecord[];
};

export type ShopifyDiscountRecord = {
  campaignId: string;
  createdOn: string;
  customerEmail: string;
  customerId: string;
  definition: {
    amount: number;
    code: string;
    condition: string;
    currency: string;
    customRewardDefinition: {
      priceRuleId: string;
      priceRuleTitle: string;
    };
    id: string;
    name: string;
    type: string;
    value: string;
  };
  exchangerType: string;
  expiration: string;
  id: string;
  ledgerAmount: number;
  ledgerCurrency: string;
  merchantId: string;
  reward: {
    amount: number;
    currency: string;
    delivery: string;
    description: string;
    discountType: string;
    processor: string;
    rewardType: string;
  };
  status: string;
  updatedOn: string;
};

export const initialState = {
  count: 0,
  records: [],
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_SHOPIFY_ACTIVE_DISCOUNTS_SUCCESS":
      return action.response.data;

    case "ACCOUNT_CREDIT_REVERSE_SUCCESS": {
      const transactionId = get(
        action.response,
        "data.reversed.original.record.id"
      );

      const indexOfExistingReward = state.records.findIndex(
        (record) => record.id === transactionId
      );

      const updatedRecords = [...state.records];

      if (indexOfExistingReward > -1) {
        updatedRecords.splice(indexOfExistingReward, 1);
      }

      return { ...state, records: updatedRecords, count: state.count - 1 };
    }

    default:
      return state;
  }
}
